const MOBILE_APP = 'mobile_app'
const MOBILE_WEB = 'mobile_web'
const WEB = 'web'

// v2.5 platforms
const WEB_DESKTOP = 'web_desktop'
const WEB_MOBILE = 'web_mobile'
const WEB_TABLET = 'web_tablet'

export { MOBILE_APP, MOBILE_WEB, WEB, WEB_DESKTOP, WEB_MOBILE, WEB_TABLET }
